module.exports = __webpack_public_path__ + "static/fonts/Oxanium-Medium.73728453.ttf";